import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl, FormGroup } from '@angular/forms';
import { TranslocoService } from '@ngneat/transloco';
import { OkAloneService } from 'src/app/ok-alone.service';

@Component({
  selector: 'app-threats',
  templateUrl: './threats.component.html',
  styleUrls: ['./threats.component.scss']
})
export class ThreatsComponent implements OnInit {

  threats: any;
  meta: any = { categories: [], severities: [] };
  sort = 'newest';

  formGroup = new FormGroup({
    search: new FormControl(''),
    severity: new FormControl(''),
    active: new FormControl('1'),
  });

  pagination = { page: 1, pageSize: 25, itemCount: 1, totalPages: 1, pageArray: [1], totalCount: 1 };

  constructor(
    private router: Router,
    public okService: OkAloneService,
    public transloco: TranslocoService
  ) { }

  ngOnInit(): void {
    this.pagination.page = 1;
    this.loadMeta();
    this.getThreats();
  }

  loadMeta(): void {
    this.okService.get('threat-management/meta', {}).subscribe((data) => {
      this.meta = data.body ?? this.meta;
    });
  }

  getThreats(): void {
    const filter = {
      sort: this.sort,
      search: this.formGroup.value.search,
      severity: this.formGroup.value.severity,
      active: this.formGroup.value.active,
      page: this.pagination.page,
    };

    this.okService.get('threat-management', filter).subscribe((data) => {
      this.threats = data.body;
      this.pagination = this.okService.setPagination(data.headers) ?? this.pagination;
    });
  }

  updateFilter(): void {
    this.pagination.page = 1;
    this.getThreats();
  }

  changePage(): void {
    this.getThreats();
  }

  cancelSearch(): void {
    this.formGroup.patchValue({ search: '' });
    this.updateFilter();
  }

  severityColor(severity: string): string {
    const map: Record<string, string> = {
      Extreme:  '#8B0000',
      Severe:   '#FF4500',
      Moderate: '#FFA500',
      Minor:    '#FFD700',
      Unknown:  '#808080'
    };
    return map[severity] || '#cccccc';
  }

  severityBadgeStyle(severity: string): { [key: string]: string } {
    return { 'background-color': this.severityColor(severity), 'color': '#fff' };
  }
}
